export const config =
  process.env.REACT_APP_ENVIRONMENT === "production"
    ? {
        apiUrl: "https://api.innercircleprints.com/api",
        oAuthUrl: "https://api.innercircleprints.com",
        pusherKey:
          process.env.REACT_APP_PUSHER_KEY || "31dfb6e435c7545606bb",
        pusherCluster: process.env.REACT_APP_PUSHER_CLUSTER || "mt1",
      }
    : {
        apiUrl: "https://stagingapi.innercircleprints.com/api",
        oAuthUrl: "https://stagingapi.innercircleprints.com",
        pusherKey:
          process.env.REACT_APP_PUSHER_KEY || "31dfb6e435c7545606bb",
        pusherCluster: process.env.REACT_APP_PUSHER_CLUSTER || "mt1",
      };
